import { render, staticRenderFns } from "./settlementTask.vue?vue&type=template&id=c44e3a5a&scoped=true&"
import script from "./settlementTask.vue?vue&type=script&lang=js&"
export * from "./settlementTask.vue?vue&type=script&lang=js&"
import style0 from "./settlementTask.vue?vue&type=style&index=0&id=c44e3a5a&prod&lang=scss&scoped=true&"
import style1 from "./settlementTask.vue?vue&type=style&index=1&id=c44e3a5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44e3a5a",
  null
  
)

export default component.exports